/**
 * /audience/:role route — Vite client-side port of the Next server
 * redirect at frontend/app/audience/[role]/page.tsx.
 *
 * In Next-land this is a server component that calls `redirect()`;
 * here it's a thin component that reads useParams and renders a
 * <Navigate>. Behaviour matches exactly:
 *
 *   /audience/banker     → /demo?lens=banker
 *   /audience/investor   → /demo?lens=investor
 *   /audience/regulator  → /demo?lens=regulator
 *   /audience/enterprise → /demo?lens=enterprise
 *   /audience/external   → /demo
 *   anything else        → /demo (typo-tolerant)
 */
import { useParams, Navigate } from "react-router-dom";

const KNOWN_LENSES = new Set(["banker", "investor", "regulator", "enterprise"]);

export function AudienceRolePage() {
  const { role } = useParams<{ role: string }>();
  const normalised = (role ?? "").toLowerCase();
  if (normalised === "external") return <Navigate to="/demo" replace />;
  if (KNOWN_LENSES.has(normalised)) return <Navigate to={`/demo?lens=${normalised}`} replace />;
  return <Navigate to="/demo" replace />;
}
